/* eslint-disable */
import React, { useEffect } from 'react';

import { motion } from 'framer-motion';
import { Header, Container } from '../../styles/shared/styles';
import { Avatar, Input, MessageBox } from 'react-chat-elements';

import 'react-chat-elements/dist/main.css';
import { InputBase, makeStyles, TextField } from '@material-ui/core';
import { ArrowUpward, Assessment, Face, PictureAsPdf } from '@material-ui/icons';
import { useRef, useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';
import api from '../../service/api';
import useSWR from 'swr';
import { fetcher } from '../../service/SWRFetcher';

import { v4 as uuidv4 } from 'uuid';
import SelectPerson from '../../components/ChatBot/Persons/SelectPerson.';
import ListPersons from '../../components/ChatBot/Persons/ListPersons';
import InputComponent from '../../components/ChatBot/Chat/Input';
import UserMessage from '../../components/ChatBot/Chat/UserMessage';
import AiMessage from '../../components/ChatBot/Chat/AiMessage';

const useStyles = makeStyles({
  chatBox: {
    maxWidth: '54em',
    width: '100%',
    overflowY: 'auto',
    borderRadius: '.8em',
    padding: '1.2em',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.2em',
    flex: 1,
    '&::-webkit-scrollbar': {
      width: '0px',
    },
  },
  aiMessage: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1.4em',
  },
  aiMessageAvatar: {
    width: '32px',
    height: '32px',
    border: '1px solid #e3e3e3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    padding: '1em',
  },
  aiMessageResponse: {
    fontSize: '1em',
    marginTop: '.4em',
  },
  // new section
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1.6em',
    height: '100%',
    paddingBottom: '.4em',
    position: 'relative',
  },
  selectPersonBox: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
});

const ChatBotPage = () => {
  const classes = useStyles();
  const inputRef = useRef();

  const [loading, setLoading] = useState(false);

  const [messages, setMessages] = useState([]);
  const [hasPrompt, setHasPrompt] = useState(false);

  const [prompt, setPrompt] = useState('');

  const [form, setForm] = useState({
    prompt: '',
    sessionId: '',
    personId: '',
  });

  const { data, mutate } = useSWR(
    form.sessionId ? `ai/chat-history?sessionId=${form.sessionId}&personId=${form.personId}` : null,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );

  const { data: persons, mutate: personsMutate } = useSWR(`ai/persona`, fetcher, {
    revalidateOnFocus: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const currentTarget = e.currentTarget;
    const formData = new FormData(currentTarget);
    const entries = formData.entries();
    const values = Object.fromEntries(entries);

    // Limpa o campo de entrada
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.focus(); // Opcional: retorna o foco ao campo
    }

    setPrompt(values.prompt);

    try {
      setLoading(true);
      const resp = await api.get(
        `/ai/chat?sessionId=${form.sessionId}&prompt=${values?.prompt}&endPointOrigin=${'sem/end/point'}&personId=${
          form.personId
        }`
      );

      const history = {
        chat_response: resp?.data?.message,
        input_prompt: values.prompt,
      };

      const newHistory = messages || [];
      newHistory.push(history);

      setMessages(newHistory);
      setLoading(false);
    } catch (e) {
      setLoading(false);

      console.log(e);
    }
  };

  const handleChangePerson = (id) => {
    setForm({
      ...form,
      personId: id,
    });

    localStorage.setItem('chat_person_id', id);
  };

  useEffect(() => {
    const sessionId = localStorage.getItem('chat_session_id');
    const personId = localStorage.getItem('chat_person_id');

    if (sessionId)
      return setForm({
        ...form,
        personId: personId || null,
        sessionId: sessionId,
      });

    const uuid = uuidv4();

    localStorage.setItem('chat_session_id', uuid);

    setSessionId(uuid);
    return setForm({
      ...form,
      personId: personId || null,
      sessionId: uuid,
    });
  }, []);

  useEffect(() => {
    setMessages([]);
  }, [form?.personId]);

  return (
    <motion.div
      style={{ height: 'calc(100% - 55px)', padding: '0px 0px 10px 10px' }}
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}>
      <div className={classes.wrapper}>
        {form.personId && (
          <div className={classes.selectPersonBox}>
            <SelectPerson value={form.personId} handleChangePerson={handleChangePerson} persons={persons} />
          </div>
        )}

        <div className={classes.chatBox}>
          {!form.personId && <ListPersons persons={persons} handleChangePerson={handleChangePerson} />}

          {form.personId && (
            <>
              {!data ? (
                <div className={classes.aiMessage}>
                  <div className={classes.aiMessageAvatar}>
                    <img src="favicon.png" width={16} height={16} />
                  </div>
                  <div className={classes.aiMessageResponse}>
                    <Typewriter
                      words={['Olá, sou o seu Assistente da Pessego. Como posso te ajudar?']}
                      loop={1}
                      typeSpeed={50}
                    />
                  </div>
                </div>
              ) : (
                <AiMessage message="Olá, sou o seu Assistente da Pessego. Como posso te ajudar?" />
              )}

              {data &&
                data?.map((chatHistory, index) => (
                  <React.Fragment key={index}>
                    <UserMessage message={chatHistory?.input_prompt} />
                    <AiMessage message={chatHistory?.chat_response} />
                  </React.Fragment>
                ))}

              {messages &&
                messages?.map((chatHistory, index) => (
                  <React.Fragment key={index}>
                    <UserMessage message={chatHistory?.input_prompt} />
                    <AiMessage message={chatHistory?.chat_response} />
                  </React.Fragment>
                ))}

              {prompt && loading && <UserMessage message={prompt} />}

              {loading && (
                <div className={classes.aiMessage}>
                  <div className={classes.aiMessageAvatar}>
                    <img src="favicon.png" width={16} height={16} />
                  </div>
                  <div className={classes.aiMessageResponse}>
                    <Typewriter
                      words={['Analisando a pergunta.', 'Consultando dados.', 'Formulando Resposta.']}
                      loop={0}
                      typeSpeed={50}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        <form
          style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onSubmit={handleSubmit}>
          <InputComponent
            personId={form.personId}
            inputRef={inputRef}
            hasPrompt={hasPrompt}
            setHasPrompt={setHasPrompt}
          />
        </form>
      </div>
    </motion.div>
  );
};

export default ChatBotPage;
